exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.autocomplete-results[data-v-de40b416]{\n  background-color: #fbfbfb;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #eee;\n  position: relative;\n  z-index: 1000;\n  width: 100%;\n}\n.autocomplete-results li[data-v-de40b416]{\n  font-size: 14px;\n  border-bottom: 1px solid #ececec;\n  padding-bottom: 10px;\n  padding-left: 10px;\n  padding-top: 10px;\n}\n.autocomplete-results li[data-v-de40b416]:hover{\n  background-color: #eee;\n}\n", ""]);

// exports
